import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import api from 'src/utils/ajax';

interface Calendar {
  id: string;
  name: string;
}

interface CalendarFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const CalendarFilter: React.FC<CalendarFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple = true,
}) => {
  const { data: calendars = [] } = useQuery({
    queryKey: ['calendars'],

    queryFn: async () => {
      const response = await api.get('/api/v4/workout-plans', {
        params: {
          only_group_calendars: true,
          for_user: true,
          pluck_columns: 'id,name',
        },
      });
      return response.data;
    },
  });

  const calendarIds = value ? String(value).split(',') : [];

  let selectedCalendar = undefined as Calendar | undefined;
  let selectedCalendars = [] as Calendar[];

  if (multiple) {
    selectedCalendars = calendars.filter((c) =>
      calendarIds?.includes(String(c.id))
    );
  } else {
    selectedCalendar = calendars.find((c) => c.id === value);
  }

  if (valueOnly) {
    if (multiple) {
      return <>{selectedCalendars?.map((c) => c.name)?.join(', ')}</>;
    }
    return <>{selectedCalendar?.name || ''}</>;
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={calendars}
      getOptionLabel={(option: Calendar) => option.name}
      value={multiple ? selectedCalendars : selectedCalendar || null}
      onChange={(_, newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((c) => c.id).join(',')
          );
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Calendar" />
      )}
    />
  );
};
